module.exports = __webpack_public_path__ + "dba2ad28671b97a38463637909cfbf93.jpg";